import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { FeaturedBrandsComponent } from './featured-brands.component';

@NgModule({
  imports: [CommonModule, UiModule],
  declarations: [FeaturedBrandsComponent],
  exports: [FeaturedBrandsComponent],
})
export class FeaturedBrandsModule {}
